module.exports = __webpack_public_path__ + "img/teeth-45.6901c2ae.png";